export default __webpack_public_path__ + "static/media/our-team-member-02.f20d0ed7.jpg";